export default function Footer() {
  return (
    <footer className="bg-teal-600 text-white py-10 sm:py-12 md:py-16 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/4ec2bf74607ae5a6da072028c7b40c06.png" 
              alt="The One Logo" 
              className="h-10 sm:h-12 w-auto mb-4 sm:mb-6 brightness-0 invert"
            />
            <p className="text-sm sm:text-base text-teal-50 leading-relaxed">
              Marketing 360 focado em crescimento estratégico e sustentável para empresas em expansão.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">Contato</h3>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-base sm:text-lg"></i>
                </div>
                <a href="mailto:contato@theonepublicidade" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors">
                  contato@theonepublicidade
                </a>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-base sm:text-lg"></i>
                </div>
                <a href="tel:+5517992623414" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors">
                  +55 17 99262-3414
                </a>
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">Redes Sociais</h3>
            <div className="flex gap-3 sm:gap-4">
              <a href="https://www.linkedin.com/in/caique-ribeiro-0265a429a/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-700 rounded-lg hover:bg-teal-800 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://www.instagram.com/theonepublicidade/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-700 rounded-lg hover:bg-teal-800 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-teal-500 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs sm:text-sm text-teal-50">
          <p className="text-center sm:text-left">
            © {new Date().getFullYear()} The One Marketing. Todos os direitos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
